import React from "react";
import { LuMoon, LuSun } from "react-icons/lu";
import { useTheme } from "../theme/ThemeContext";

function ThemePreference() {
  const { isDark, toggleTheme } = useTheme();
  return <section className="account-menu-section ios-theme-preference">
    <h2>Tema</h2>
    <button type="button" className="account-menu-card ios-theme-preference-button" onClick={toggleTheme}
      aria-label={`Tema: ${isDark ? "Escuro. Mudar para claro" : "Claro. Mudar para escuro"}`}>
      {isDark ? <LuSun aria-hidden="true" /> : <LuMoon aria-hidden="true" />}
      <span>Tema</span><strong>{isDark ? "Escuro" : "Claro"}</strong>
    </button>
  </section>;
}

export default function IOSThemePreference() {
  return <ThemePreference />;
}
